module.exports = __webpack_public_path__ + "img/四川天府新区博恩海昌幼儿园.cc9c67b8.jpg";